"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileshareOptionsValidationSchema = void 0;
exports.FileshareOptionsValidationSchema = {
    name: 'fileshareOptionsValidationSchema',
    properties: {
        accountName: [
            {
                type: 'isNotEmpty',
            },
        ],
        directory: [
            {
                type: 'isNotEmpty',
            },
        ],
        fileshare: [
            {
                type: 'isNotEmpty',
            },
        ],
        fileName: [
            {
                type: 'isNotEmpty',
            },
        ],
    },
};
//# sourceMappingURL=fileshare-options-validation-schema.js.map